import { inject, Injectable } from '@angular/core';
import { WebProviderService } from '../web/web.provider.service';
import { assert } from 'src/app/utils/assert.util';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class APIProviderService<T> {
  protected webProvider = inject(WebProviderService);
  protected readonly baseURL = environment.apiURL;
  protected get attributeURL() {
    return '/api';
  }

  async get(retailerIframeID: string | null): Promise<T[]> {
    const url = new URL(`${this.baseURL}${this.attributeURL}`);
    if (retailerIframeID) {
      url.searchParams.set('retailerIframeID', retailerIframeID);
    }
    const attributes = await this.webProvider.get<T[]>(url.href);
    assert(attributes, 'Failed to fetch attribute');
    return attributes;
  }
}
